<template>
  <div class="ll-member-list-title-row">
    <p class="ll-member-list_list-title">
      {{ $t('成員列表') }}
    </p>
    <div class="ll-member-list_title-tools">
      <div class="ll-member-list_tool-number">
        <p class="number-item">
          {{ $t('共{number}個成員',{number:totalNumber}) }}
        </p>
        <p class="number-item">
          {{ $t('啟用帳號') }}
        </p>
        <p
          class="number-item"
          style="margin-left:10px;"
        >
          {{ usingNumber }}/{{ maxNumber }}
        </p>
        <!-- 目前先註解到，等之後安排 -->
        <!-- <WsTextButton001
          primary
          no-padding
          narrow
          font-size-md
          @click="$_addPopupOpen()"
        >
          {{ $t('點此申請更多帳號數量') }}
        </WsTextButton001> -->
      </div>
      <SearchInput
        v-model="searchInputButton.value"
        :placeholder="searchInputButton.placeholder"
        @enter="$_searchAccountClick()"
      />
    </div>
    <PopUp
      :clickOutsideClose="false"
      :pop-up-active="addPopupActive"
      :title="$t('申請子帳號數量')"
      @click="$_addPopupClose()"
    >
      <LlCancelPopupContent>
        <ControlNumberCard v-model="addAccountNumber" />
        <InputTextareaButton
          v-model="addAccountRemark"
          :title="$t('備註')"
          :margin-top="20"
          :min-height="90"
        />
        <template v-slot:buttons>
          <WsButton001
            out-line
            @click="$_addPopupClose()"
          >
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_addAccountClick()">
            {{ $t('送出') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>
<script>
export default {
  name: "LlMemberListTitleRow",
  props: {
    maxNumber: {
      type: Number,
      default: 0,
    },
    usingNumber: {
      type: Number,
      default: 0,
    },
    totalNumber: {
      type: Number,
      default: 0,
    },
    searchInputButtonValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchInputButton: {
        value: "",
        placeholder: this.$t("以姓名/帳號搜尋"),
      },
      addPopupActive: false,
      addAccountRemark: "",
      addAccountNumber: 1,
    };
  },
  watch: {
    searchInputButtonValue: {
      handler() {
        this.$_setSearchValue();
      },
    },
  },
  mounted() {
    this.$_setSearchValue();
  },
  methods: {
    $_addPopupOpen() {
      this.addPopupActive = true;
    },
    $_addPopupClose() {
      this.addPopupActive = false;
      this.$_clearData();
    },
    $_addAccountClick() {
      let applyData = {
        applyNumber: this.addAccountNumber + this.maxNumber,
        remark: this.addAccountRemark,
      };
      this.$emit("apply-account", applyData);
      this.$_addPopupClose();
    },
    $_searchAccountClick() {
      this.$emit("search-account", this.searchInputButton.value);
    },
    $_clearData() {
      this.addAccountRemark = "";
      this.addAccountNumber = 1;
    },
    $_setSearchValue() {
      this.searchInputButton.value = this.searchInputButtonValue;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-member-list-title-row";
</style>